import { styled } from 'linaria/react';
import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const StoreConveniencesContainer = styled.div`
  display: grid;
  grid-row-gap: 16px;
  grid-template-columns: 1fr 1fr;

  ${breakpoints.only.tablet} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
export const iconBaseline = css`
  margin-right: var(--space-200);
  vertical-align: middle;
`;
